import React from 'react';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  isLoading?: boolean;
  fullWidth?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  isLoading,
  fullWidth,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-lg font-medium transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-[#d4a574] hover:bg-[#c39260] text-[#1a1f3a] focus:ring-[#d4a574] shadow-lg hover:shadow-xl hover:-translate-y-0.5',
    secondary: 'bg-[#1a1f3a] hover:bg-[#2a3055] text-white focus:ring-[#1a1f3a]',
    outline: 'border-2 border-[#1a1f3a] text-[#1a1f3a] hover:bg-[#faf8f5] focus:ring-[#1a1f3a]'
  };
  const sizes = 'px-8 py-4 text-lg';
  const width = fullWidth ? 'w-full' : '';
  return <button className={`${baseStyles} ${variants[variant]} ${sizes} ${width} ${className}`} disabled={isLoading} {...props} data-id="element-236">
      {isLoading && <Loader2 className="mr-2 h-5 w-5 animate-spin" data-id="element-237" />}
      {children}
    </button>;
}